mutation DeleteSentenceGroup($id: ID!) {
  deleteSentenceGroup(id: $id) {
    ok
    errors
  }
}
